import React from 'react';

import { LeaderboardRunAliasesContext } from '@neptune/shared/leaderboard-domain';

export const useLeaderboardRunAliasesContext = () => {
  return React.useContext(LeaderboardRunAliasesContext);
};
